<template>
    <div>
        <div class="header_unit header_bg_white">
            <div class="header_box">
                <div class="menu_left">
                  <router-link class="icn_back_black" :to="{ name: 'managemenu' , params: {brandPath: this.$route.params.brandPath}} "><p class="top_tit">＜戻る</p></router-link>
                </div>
                <div class="menu_center">
                  <p class="menu_center_tex_l top_tit">お知らせ設定</p>
                </div>
                <div class="menu_right">
                </div>
            </div>
        </div>
        <ReleaseList />
    </div>
</template>

<script>
    // @ is an alias to /src
    import ReleaseList from '@/app/components/ReleaseList.vue'

    export default {
        name: 'releaseSettingIndex',
        components: {
          ReleaseList
        },
        props: {
            menuId: Number,
        }
    }
</script>
